"use strict";
/* --------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockUsedByThisInstanceSingleton = void 0;
const crypto = require("crypto");
class LockUsedByThisInstanceSingleton {
    constructor(lockStringAndThisVsCodeInstanceOwnsIt = {}) {
        this.lockStringAndThisVsCodeInstanceOwnsIt = lockStringAndThisVsCodeInstanceOwnsIt;
        this.everSpawnedSudoSuccessfully = false;
        this.currentAliveStatus = false;
        this.sudoError = null;
    }
    static getInstance() {
        if (!LockUsedByThisInstanceSingleton.instance) {
            LockUsedByThisInstanceSingleton.instance = new LockUsedByThisInstanceSingleton();
        }
        return LockUsedByThisInstanceSingleton.instance;
    }
    hasSpawnedSudoSuccessfullyWithoutDeath() {
        return this.everSpawnedSudoSuccessfully;
    }
    killingSudoProc() {
        this.everSpawnedSudoSuccessfully = false;
    }
    isCurrentSudoProcCheckAlive() {
        return this.currentAliveStatus;
    }
    /*
    You must set it back to false when the check is done.
    */
    setCurrentSudoCheckAsAlive(alive) {
        if (alive) {
            this.everSpawnedSudoSuccessfully = true;
        }
        this.currentAliveStatus = alive;
    }
    sudoProcError() {
        return this.sudoError;
    }
    setSudoProcError(err) {
        this.sudoError = err;
    }
}
exports.LockUsedByThisInstanceSingleton = LockUsedByThisInstanceSingleton;
LockUsedByThisInstanceSingleton.SUDO_SESSION_ID = crypto.randomUUID().substring(0, 8);
//# sourceMappingURL=LockUsedByThisInstanceSingleton.js.map